module.exports = __webpack_public_path__ + "img/2012-08-18 12.29.25.be7f5f3b.jpg";